import { Brand, Img } from "./DeckShell";

/* Felles kinematisk cover for alle deck (én identitet): Grieghallen i skumring full-bleed, Kevin O'Leary som s/h-frilegg i høyre tredjedel
   mot fasade fadet til mørke, tittel nederst til venstre (1–3 linjer, størrelse etter antall), undertittel, indeksrad i fire kolonner.
   Statusmodell: Kevin er «Proposed opening keynote · Availability confirmed» — aldri «headliner confirmed». */
const KEVIN_CUT = "/images/headliner/kevin-cover-clean.webp";
export const CINE_ASSETS = ["/images/grieghallen.webp", KEVIN_CUT];

const KEVIN_CAP = ["Proposed opening keynote", "Kevin O'Leary", "Availability confirmed · not yet contracted"];

export const CinematicCover = ({ lockup, label, title, sub, index, kevin = true, kevinCap = KEVIN_CAP, className = "", testid = "hd-cover" }) => {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className={`hd-slide hd-cover vd-cover vd-cover-l${lines.length} ${className}`} data-testid={testid}>
      <Img className="vd-cover-img" src="/images/grieghallen.webp" alt="Grieghallen, Bergen" draggable={false} fetchPriority="high" />
      <div className="vd-cover-shade" aria-hidden />
      {kevin && (
        <figure className="vd-cover-kevin" data-testid="vd-cover-kevin">
          <Img src={KEVIN_CUT} alt="Kevin O'Leary" draggable={false} fetchPriority="high" />
        </figure>
      )}
      <div className="hd-top">
        {lockup || <Brand size={17} className="hd-brand" />}
        {label && <span className="hd-label" data-testid="vd-cover-variant">{label}</span>}
      </div>
      <div className="vd-cover-txt">
        <h1 className="vd-cover-h" data-testid="vd-cover-h">{lines.map((l, i) => <i key={i}>{l}</i>)}</h1>
        {sub && <p className="vd-cover-sub" data-testid="vd-cover-sub">{sub}</p>}
      </div>
      <div className="hd-index vd-cover-index" data-testid="vd-index">
        {index.map(([k, v, cls, tid]) => <span key={k} className={cls || ""} data-testid={tid}><i className="k">{k}</i>{v}</span>)}
        {kevin && <span className="kev" data-testid="vd-cover-kevin-cap"><i className="k">{kevinCap[0]}</i>{kevinCap[1]}<em className="st">{kevinCap[2]}</em></span>}
      </div>
    </section>
  );
};
